import styled, { css } from 'styled-components';

const StyledInputContainer = styled.div`${
  (props) => {
    const { styled } = props;
    return css`
     && {
       input:-webkit-autofill {
         -webkit-text-fill-color: ${styled?.color} !important;;
         -webkit-box-shadow:0 0 0 50px ${styled?.backgroundColor} inset !important;
       }
        margin: 7px 0;
        position: relative;
    
        .form-group > input[type='checkbox'], .control-label {
          display: inline;
          margin: 0 .2em .6em 0;
        }
    
        label {
          margin-top: 0;
          margin-bottom: .3em;
        }
    
        select, input[type='text'], textarea {
          width: 100%;
          border-color: ${styled?.color};
          border-radius: ${styled?.inputsBorderRadius}px;  
        }

        input::placeholder, textarea::placeholder,
        input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
          color: ${styled?.color};
          opacity: 1;  
        }
     }`;
  }
}`;

export default StyledInputContainer;
